import {addClass, removeClass} from './../supports/utils';

class SearchableTables {
    init() {
        const tableContainers = document.querySelectorAll('.table-searchable');
        tableContainers.forEach(container => new SearchableTable(container));
    }
}

class SearchableTable {
    constructor(container) {
        this.container = container;

        if (!this.container) {
            return;
        }

        this.searchInput = this.container.querySelector('input');
        this.table = this.container.querySelector('table');
        this.tableFilterableRows = this.table.querySelectorAll('.filterable-row');

        this.initSearch();
    }

    initSearch() {
        this.searchInput.addEventListener('input', () => {
            const query = this.searchInput.value.toLowerCase();

            if (query === '') {
                this.showAll();
            }

            this.tableFilterableRows.forEach(row => {
                const stringToBeSearched = row.dataset.filter.toLowerCase();

                if (stringToBeSearched.indexOf(query) > -1) {
                    this.showRow(row);
                } else {
                    this.hideRow(row);
                }
            });
        });
    }

    showRow(row) {
        removeClass(row, 'hidden');
    }

    hideRow(row) {
        addClass(row, 'hidden');
    }

    showAll() {
        this.tableFilterableRows.forEach(row => this.showRow(row));
    }
}

export default new SearchableTables();
